<template>
  <div class="bg-gray-600">
    <div class="upload videouploadLoader">
      <div
        class="w-full text-center mx-auto"
        :style="{
          display: !displayUploadbox ? 'inline-block' : 'none',
        }"
      >
        <div
          class="w-24 h-24 rounded-full bg-grey-300 flex items-center justify-center m-auto"
        >
          <img src="../../assets/images/videos/upload.png" alt />
        </div>
        <h3 class="mt-6 mb-2 dropzone-custom-title">
          {{ $t('frontend_groovevideo_videos_fileupload_drag') }}
        </h3>
        <gd-tabs
          :tabs="uploadTabs"
          :currentTab="currentTab"
          :disableNotCompleted="true"
          :wrapper-class="'px-0 gs-default-tabs'"
          :tab-active-class="'border-pink border-b-2 text-pink gs-default-tabs-item-active'"
          :line-class="'gs-default-tabs-active-line'"
          @onClick="handleTabChange"
          class="uploadTab"
          :key="this.$t('frontend_groovevideo_videos_fileupload_mycomputer')"
        />
        <div class="fill-w">
          <div class="py-4 px-2" v-if="currentTab === 'step1'">
            <vue-dropzone
              id="customdropzone"
              ref="myVueDropzone"
              :options="dropzoneOptions"
              :use-custom-slot="true"
              @vdropzone-s3-upload-error="s3UploadError"
              @vdropzone-s3-upload-success="s3UploadSuccess"
              @vdropzone-upload-progress="uploadProgress"
              @vdropzone-total-upload-progress="totalProgress"
              @vdropzone-file-added="fileAdded"
            >
              <div class="dropzone-custom-content">
                <!-- <div
                  class="w-24 h-24 rounded-full bg-grey-300 flex items-center justify-center m-auto"
                >
                  <img src="../assets/images/videos/upload.png" alt />
                </div>
                <h3 class="mt-6 mb-2 dropzone-custom-title">
                  Drag and drop video files to upload
                </h3> -->
                <p class="text-sm text-grey mb-4">
                  {{ $t('frontend_groovevideo_videos_fileupload_upload') }}
                </p>
                <div
                  class="border-dashed rounded-lg bgcolor border-grey-100 border flex flex-col h-40 justify-center items-center px-4"
                >
                  <div class="text-xs subtitle mb-3">
                    {{ $t('frontend_groovevideo_videos_fileupload_drag_drop') }}
                    <br />
                    {{ $t('frontend_groovevideo_videos_fileupload_or') }}
                  </div>
                  <div
                    class="w-full flex flex-row flex-no-wrap items-center justify-center"
                  >
                    <gd-button primary class="px-4 w-auto mr-2">
                      {{ $t('frontend_groovevideo_videos_selectfile') }}
                    </gd-button>
                  </div>
                  <div
                    class="p-2 flex flex-row flex-no-wrap items-center justify-center text-xs subtitle text-pink"
                  >
                    {{ $t('frontend_groovevideo_video_size_limit') }}
                  </div>
                </div>
              </div>
            </vue-dropzone>
          </div>
          <div class="py-4 px-2" v-if="currentTab === 'step2'">
            <text-input
              v-model="model.youtubeUrl"
              :validator="$v.model.youtubeUrl"
              value="model.youtubeUrl"
              attribute="youtubeUrl"
              :placeholder="$t('frontend_groovevideo_videos_eg_youtube')"
            />
            <gd-button
              size="auto"
              class="py-4 mt-6 px-8 mr-2"
              @click="youtubeVideoLink"
            >
              {{ $t('frontend_save') }}
            </gd-button>
          </div>
          <div class="py-4 px-2" v-if="currentTab === 'step3'">
            <text-input
              v-model="model.mp4Url"
              :validator="$v.model.mp4Url"
              value="model.mp4Url"
              attribute="Mp4 URL"
              :placeholder="$t('frontend_groovevideo_videos_eg_mp4')"
            />
            <gd-button
              size="auto"
              class="py-4 mt-6 px-8 mr-2"
              @click="mp4VideoLink"
            >
              {{ $t('frontend_save') }}
            </gd-button>
          </div>
          <!-- <div
            class="absolute bottom-0 left-0 w-full flex justify-center item-center bg-pink rounded-br rounded-bl p-2"
          >
            <p class="text-white text-sm">
              {{ $t('frontend_groovevideo_videos_getfree_access') }}
              <gd-button
                size="large"
                v-if="!$store.getters.canUseStorage"
                class="text-center bg-white upgradeBtn ml-2"
              >
                {{ $t('frontend_groovevideo_videos_upgrade_pro') }}
              </gd-button>
            </p>
          </div> -->
        </div>
        <div
          v-if="this.videoDetails.video_source"
          class="w-full flex justify-center"
        >
          <gd-button primary class="">
            {{ $t('frontend_cancel') }}
          </gd-button>
        </div>
      </div>
      <div
        class="dz-preview dz-file-preview outputDisplay"
        v-if="displayUploadbox"
      >
        <div class="w-full text-center p-4">
          <div class="preview">
            <div class="c100 m-auto pink" :class="'p' + uploadProgressStatus">
              <span>{{ uploadProgressStatus }} %</span>
              <div class="slice">
                <div class="bar"></div>
                <div class="fill"></div>
              </div>
            </div>
            <h6 class="mt-3 w-full inline-block">
              {{ $t('frontend_groovevideo_videos_uploading') }}
            </h6>
            <p class="mt-2">
              {{ $t('frontend_groovevideo_videos_wait_until') }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import { fetchActivity } from '@/api/index.js';
import Loading from 'vue-loading-overlay';
import themeConfig from '@/theme/themeConfig.js';
import Swal from 'sweetalert2';
import Auth from '@groovepages/gd-lib/auth';
import axios from 'axios';
import SourceType from '@/models/SourceType.js';
import { required, url } from 'vuelidate/lib/validators';

export default {
  components: {
    vueDropzone: vue2Dropzone,
  },
  props: {
    storageId: {
      default() {
        return 0;
      },
    },
    storageFolder: {
      default() {
        return 0;
      },
    },
    encoderId: {
      default() {
        return 0;
      },
    },
    isPaid: {
      type: Boolean,
      default() {
        return {};
      },
    },
    headers: {},
    maxSize: {},
    videoDetails: {},
  },
  data() {
    return {
      model: '',
      fullPageLoader: true,
      isLoading: false,
      loaderColor: themeConfig.appPrimaryColor,
      files: [],
      user: null,
      vid: this.$route.params.id,
      newActivity: {
        status: '',
        msg: '',
      },
      usedData: [],
      isEnabled: 1,
      uploadProgressStatus: 0,
      btnVisible: '',
      dropzoneOptions: {
        acceptedFiles: '.mp4,.webm,.flv',
        url: `${window.config.apiUrl}/packageupload/`+this.$route.params.id,
        headers: {'Authorization': 'Bearer '+Auth.authenticatedUser().token, 'x-auth-provider': 'auth0'},
        chunking: true,      // enable chunking
        forceChunking: true, // forces chunking when file.size < chunkSize
        parallelChunkUploads: true, // allows chunks to be uploaded in parallel (this is independent of the parallelUploads option)
        chunkSize: 10000000,  // chunk size 1,000,000 bytes (~1MB)
        retryChunks: false,   // retry chunks on failure
        retryChunksLimit: 3, // retry maximum of 3 times (default is 3)
        parallelUploads: 1,
        timeout: 99999999,
        maxFiles: 1,
        maxFilesize: this.maxSize,
        autoProcessQueue: false,
        autoQueue: true,
      },
      currentTab: 'step1',
      uploadTabs: [
        {
          title: this.$t('frontend_groovevideo_videos_fileupload_mycomputer'),
          value: 'step1',
        },
        // {
        //   title: this.$t('frontend_groovevideo_videos_fileupload_youtube'),
        //   value: 'step2',
        // },
        // {
        //   title: this.$t('frontend_groovevideo_videos_fileupload_link'),
        //   value: 'step3',
        // },
      ],
      model: {
        youtubeUrl: '',
        mp4Url: '',
      },
      displayUploadbox: false,
      nextButtonDisabled: true,
      video_source_type: [],
    };
  },
  validations: {
    model: {
      youtubeUrl: {
        required,
        url,
      },
      mp4Url: {
        required,
        url,
      },
    },
  },

  mounted() {
    this.url = `${window.config.apiUrl}/upload`;
    this.user = this.$store.state.user.id;
  },
  methods: {
    validate() {
      this.$v.$touch();
      const isValid = !this.$v.$invalid;
      this.$emit('on-validate', isValid);
      return isValid;
    },
    s3UploadError(errorMessage) {
      const self = this;
      self.hideLoader();
      self.newActivity = 'failed';
      self.createActivity();
      self.$refs.myVueDropzone.enable();
      self.isEnabled = 1;
    },
    uploadProgress(file, progress, bytesSent) {
      this.uploadProgressStatus = progress;
      this.uploadProgressStatus = Math.round(this.uploadProgressStatus);
    },
    totalProgress(totaluploadprogress, totalBytes, totalBytesSent) {
      console.log(totaluploadprogress, totalBytes, totalBytesSent);
    },
    fileAdded(file) {
      const fileSize = (file.size / (1000 * 1000)).toFixed(1);
      // Max File Size Check
      if (fileSize > this.maxSize) {
        // Remove file in case greater than allowed file size
        this.$refs.myVueDropzone.removeFile(file);

        // Show error message
        Swal.fire(
          this.$t('frontend_upload_error'),
          'Files larger than ' + this.maxSize + 'MB are not allowed.',
          'error'
        );
      } else {
        const self = this;
        // Timeout lets added file to get queued for processing
        setTimeout(() => {
          // Check queued file
          if (self.$refs.myVueDropzone.getQueuedFiles().length) {
            const element = self.$el.querySelector('#customdropzone');
            if (element.classList.contains('dz-started')) {
              self.displayUploadbox = true;
            }
            // Initiate file upload
            self.$refs.myVueDropzone.processQueue();
          }
        }, 300);
      }
    },
    async s3UploadSuccess(s3ObjectLocation) {
      const self = this;
      const files = self.$refs.myVueDropzone.getAcceptedFiles();
      if (files.length) {
        const fileSize = files[0].size;

        const s3UploadSuccessData = await axios.post('/upload', {
          vid: self.vid,
          storageId: self.storageId,
          encoderId: self.encoderId,
          folder: self.storageFolder,
          isPaid: self.isPaid,
          fileLink: s3ObjectLocation,
          fileSize,
        });

        const uploadResponse = s3UploadSuccessData.data;
        console.log('---------', uploadResponse);
        if (uploadResponse.status == 'uploading') {
          self.newActivity = 'uploading';
          this.btnVisible = 'progress100';
          this.nextButtonDisabled = false;
          self.createActivity();
          this.addVideo();
        } else if (uploadResponse.status == 'encoding') {
          self.$refs.myVueDropzone.disable();
          self.isEnabled = 0;
          self.hideLoader();
          self.newActivity = 'encoding';
          this.btnVisible = 'progress100';
          this.nextButtonDisabled = false;
          self.createActivity();
          this.addVideo();
        } else if (uploadResponse.status == 'uploaded') {
          self.$refs.myVueDropzone.disable();
          self.isEnabled = 0;
          self.hideLoader();
          self.newActivity = 'uploaded';
          this.btnVisible = 'progress100';
          this.nextButtonDisabled = false;
          self.createActivity();
          this.addVideo();
        } else {
          self.hideLoader();
          self.newActivity = 'failed';
          this.btnVisible = 'progress100';
          self.createActivity();
          self.$refs.myVueDropzone.removeAllFiles();
          self.$refs.myVueDropzone.enable();
          self.isEnabled = 1;
        }
      }
    },
    showLoader() {
      this.$emit('showLoader');
    },

    hideLoader() {
      this.$emit('hideLoader');
    },

    createActivity() {
      this.$emit('activityCreated', this.newActivity);
    },

    startUploading() {
      if (
        this.$refs.myVueDropzone.getAcceptedFiles().length > 0 &&
        this.isEnabled
      ) {
        this.showLoader();
        this.$refs.myVueDropzone.processQueue();
      }
    },

    addVideo() {
      console.log('chunkupload', this.newActivity);
      // Redirect only when button is active
      if (!this.nextButtonDisabled) {
        this.$router.push({
          name: 'AddNewVideo',
          params: { activityCreated: this.newActivity },
        });
      }
    },
    handleTabChange(newTab) {
      this.currentTab = newTab;
    },

    async mp4VideoLink() {
      this.$v.model.mp4Url.$touch();
      if (!this.$v.model.mp4Url.$invalid) {
        this.showLoader();
        this.video_source_type = await new SourceType({});
        this.video_source_type.vid = this.$route.params.id;
        this.video_source_type.type = 3;
        this.video_source_type.source = this.model.mp4Url;
        this.video_source_type.save().then((res) => {
          if (res.status == 'success') {
            this.$router.push({ name: 'AddNewVideo', params: { mode: 'Mp4' } });
          }
        });
      }
    },
    async youtubeVideoLink() {
      this.$v.model.youtubeUrl.$touch();
      if (!this.$v.model.youtubeUrl.$invalid) {
        this.showLoader();
        this.video_source_type = await new SourceType({});
        console.log(this.video_source_type);
        this.video_source_type.vid = this.$route.params.id;
        this.video_source_type.type = 2;
        this.video_source_type.source = this.model.youtubeUrl;
        this.video_source_type.save().then((res) => {
          if (res.status == 'success') {
            this.$router.push({
              name: 'AddNewVideo',
              params: { mode: 'youtube' },
            });
          }
        });
      }
    },
  },
};
</script>

<style>
@import '../../assets/css/progressbar.css';
#customdropzone .dz-preview .dz-details {
  color: white;
  background-color: #fd6481 !important;
  transition: opacity 0.2s linear;
  text-align: center;
}

.upload.videouploadLoader .dz-message {
  margin: 0;
}

.upload.videouploadLoader {
  width: 372px;
  margin: 0 auto;
}

#customdropzone {
  border: 0;
  background: transparent;
  padding: 0;
}

#customdropzone h3 {
  font-size: 20px !important;
  color: #191d3a;
}

#customdropzone {
  text-align: center !important;
}
.upload.videouploadLoader .vue-dropzone .dz-preview {
  display: none !important;
}
.upload.videouploadLoader .vue-dropzone + .dz-preview.outputDisplay {
  display: none !important;
}

.upload.videouploadLoader .vue-dropzone.dz-started + .dz-preview.outputDisplay {
  display: inline-block !important;
}

.dz-progress {
  width: 60px !important;
  height: 60px !important;
  background-color: transparent;
  border-radius: 50% !important;
  display: inline-block;
  border-color: #989ab2;
  border-width: 5px;
  border-style: solid;
}

.upload.videouploadLoader .bgcolor {
  background: #f3f3f5;
}

.dropzone .dz-preview.dz-complete .dz-progress {
  opacity: 1 !important;
}

.videouploadLoader .dz-preview h6 {
  color: #191d3a;
  font-size: 20px !important;
}
.videouploadLoader .dz-preview p {
  color: #989ab2;
  font-size: 14px;
}

.videouploadLoader .dropzone .dz-preview {
  margin: 0;
  width: 100%;
  height: 100%;
}

.nextbtn,
.nextbtn:hover {
  background: #d5d8e5;
}

.nextbtn.progress100 {
  background: #ea3d5e;
}
.upgradeBtn {
  border-color: white !important;
}

.dz-preview.dz-file-preview.uploadMsg {
  display: inline-block !important;
}
</style>
